import i18n from '../i18n';
import { normalizeLocale } from '../i18n/languages';
import { applyDocumentDirection } from '../i18n/documentDirection';
import { markUserLanguageChoice } from './domainLanguage';

/**
 * Единая точка смены языка UI (все переключатели должны вызывать только её).
 */
export async function changeLanguage(code) {
    const normalized = normalizeLocale(code);
    if (!normalized) return;

    await i18n.changeLanguage(normalized);
    markUserLanguageChoice(normalized);
    localStorage.setItem('sp_locale_confirmed', 'true');
    applyDocumentDirection(normalized);
}
